import _typeof from "@babel/runtime/helpers/esm/typeof";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { MODAL_SIZES } from '../../constants';

/**
 * Transform media query (prop or inline) to size inline media query
 *
 * @param {string} data.defaultSize Either `xs` or `md`
 * @param {boolean} data.fullScreen Replaces default size with `fullScreen` is true
 * @param {object} data.object Inline media query or legacy media query object
 * @param {string} data.valueKey Nested value key for legacy media query object
 * @returns {object} Inline media query object
 */
export var transformMediaQueryObject = function transformMediaQueryObject(_ref) {
  var defaultSize = _ref.defaultSize,
    fullScreen = _ref.fullScreen,
    object = _ref.object,
    valueKey = _ref.valueKey;
  return Object.entries(object).reduce(function (accumulator, _ref2) {
    var _Object$assign;
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return Object.assign({}, accumulator, (_Object$assign = {}, _Object$assign[key] = (valueKey ? value[valueKey] : value) === true ? MODAL_SIZES.FULL_SCREEN : defaultSize, _Object$assign));
  }, {
    default: fullScreen ? MODAL_SIZES.FULL_SCREEN : defaultSize
  });
};

/**
 * Translate deprecated dimension props to the new `size` prop.
 * Required for backward compatibility.
 *
 * @param {boolean|object} props.fullScreen
 * @param {object} props.mediaQuery
 * @param {string|object} props.size
 * @param {boolean} props.wide
 * @returns {string|object} Size enum value or inline media query object
 */
export var getSize = function getSize(_ref4) {
  var fullScreen = _ref4.fullScreen,
    mediaQuery = _ref4.mediaQuery,
    size = _ref4.size,
    wide = _ref4.wide;
  var defaultSize = wide ? MODAL_SIZES.MD : MODAL_SIZES.XS;
  if (wide && !mediaQuery && _typeof(fullScreen) !== 'object' && _typeof(size) !== 'object') {
    return MODAL_SIZES.MD;
  }
  if (mediaQuery) {
    return transformMediaQueryObject({
      defaultSize: defaultSize,
      fullScreen: fullScreen,
      object: mediaQuery,
      valueKey: MODAL_SIZES.FULL_SCREEN
    });
  }
  if (fullScreen) {
    if (typeof fullScreen === 'boolean') {
      return MODAL_SIZES.FULL_SCREEN;
    }
    if (_typeof(fullScreen) === 'object') {
      return transformMediaQueryObject({
        defaultSize: defaultSize,
        object: fullScreen
      });
    }
  }
  if (_typeof(size) === 'object') {
    return Object.assign({
      default: defaultSize
    }, size);
  }
  return size;
};